'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_TYPES = undefined;

exports.default = function (trackingConfig) {
  return {
    INPUT_TYPES: INPUT_TYPES,

    /**
     * Integrates with the NWA library to dispatch the form input changed.
     *
     * @param fieldInfo The tracking info associated with the field
     *
     * @param fieldInfo.inputType [Optional] The type of input, as specified by the HTML input element. Defaults to 'text'
     * @param fieldInfo.fieldName Human-readable(-ish) name of a field, i.e. yearly-income. Should be drawn from the input's label element.
     *
     */
    trackInputChange: function trackInputChange(fieldInfo) {
      // Trigger the form input changed event.
      (0, _tracking.formInputChanged)((0, _assign2.default)({
        inputType: INPUT_TYPES.TEXT
      }, trackingConfig, fieldInfo));
    }
  };
};

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

var _tracking = require('@nerdwallet/nw-client-lib/tracking');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Enum for some of input types supported on an HTML input.
 *
 * @readonly
 * @enum {String}
 */

var INPUT_TYPES = exports.INPUT_TYPES = (0, _keymirror2.default)({
  BUTTON: null,
  CHECKBOX: null,
  COLOR: null,
  DATE: null,
  DATETIME: null,
  DATETIME_LOCAL: null,
  EMAIL: null,
  FILE: null,
  HIDDEN: null,
  IMAGE: null,
  MONTH: null,
  NUMBER: null,
  PASSWORD: null,
  RADIO: null,
  RANGE: null,
  RESET: null,
  SEARCH: null,
  SUBMIT: null,
  TEL: null,
  TEXT: null,
  TIME: null,
  URL: null,
  WEEK: null
}); /* eslint max-len: 0 */